export default $axios => {
  return {
    /**
     * 提交数据
     * @param {object} options
     */

    goForm(options) {
      return $axios.post('/discount/confirm', options)
    }

  }
}